export default "__VITE_ASSET__94bUNcxr__"